import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

const routes = (): RouteRecordRaw[] => {
  const config = useRuntimeConfig()

  return [
    {
      name: ROUTE_NAMES.CUSTOMER_CARE.INDEX,
      component: () =>
        import('~/scopes/customer-care/pages/customer-care/CustomerCare.vue'),
      path: '/bo-seller/customer-care',
      redirect: {
        name: ROUTE_NAMES.CUSTOMER_CARE.OPEN_TASKS,
      },
      meta: { owners: ['bot-squad-seller-care-front'] },
      children: [
        {
          component: () =>
            import(
              '~/scopes/customer-care/pages/customer-care/components/OpenTasks/OpenTasks.vue'
            ),
          name: ROUTE_NAMES.CUSTOMER_CARE.OPEN_TASKS,
          path: 'open-tasks',
          meta: { owners: ['bot-squad-seller-care-front'] },
        },
        {
          component: () =>
            import(
              '~/scopes/customer-care/pages/customer-care/components/Refunds/Refunds.vue'
            ),
          redirect: config.public
            .FF_BO_SELLER_IS_NEW_CUSTOMER_CARE_REFUND_TAB_ENABLED
            ? undefined
            : {
                name: ROUTE_NAMES.CUSTOMER_CARE.INDEX,
              },
          children: [],
          name: ROUTE_NAMES.CUSTOMER_CARE.REFUNDS,
          path: 'refunds',
          meta: { owners: ['bot-squad-seller-care-front'] },
        },
        {
          component: () =>
            import(
              '~/scopes/customer-care/pages/customer-care/components/AllRequests/AllRequests.vue'
            ),
          name: ROUTE_NAMES.CUSTOMER_CARE.ALL_REQUESTS,
          path: 'all-requests',
          meta: { owners: ['bot-squad-seller-care-front'] },
        },
      ],
    },
    {
      /**
       * The following route will be soon deprecated – maintenance mode only for the period of CP2.0 migration.
       */
      name: ROUTE_NAMES.CUSTOMER_CARE.REQUEST_RESOLUTION,
      component: () =>
        import(
          '~/scopes/customer-care/pages/customer-request/CustomerRequest.vue'
        ),
      path: '/bo-seller/customer-care/help-requests/resolutions/:resolutionId',
      meta: {
        layout: 'help-request',
        middleware: ['fetch-customer-request-id-and-redirect'],
        owners: ['bot-squad-seller-care-front'],
      },
    },
    {
      /**
       * @deprecated The following route will be soon deprecated – maintenance mode only for the period of CP2.0 migration.
       */
      name: ROUTE_NAMES.CUSTOMER_CARE.CUSTOMER_REQUEST,
      component: () =>
        import(
          '~/scopes/customer-care/pages/customer-request/CustomerRequest.vue'
        ),
      path: '/bo-seller/customer-care/help-requests/:customerRequestId/:claimId?',
      meta: {
        layout: 'help-request',
        owners: ['bot-squad-seller-care-front'],
      },
    },
    {
      name: ROUTE_NAMES.CUSTOMER_CARE.REQUEST,
      path: '/bo-seller/customer-care/conversation/:orderlinePublicId',
      component: () =>
        import('~/scopes/customer-care/pages/request/Request.vue'),
      redirect: config.public
        .FF_BO_SELLER_IS_NEW_CUSTOMER_CARE_INTERCOM_REQUEST_OPEN
        ? undefined
        : {
            name: ROUTE_NAMES.CUSTOMER_CARE.INDEX,
          },
      children: [],
      meta: {
        layout: 'help-request',
        owners: ['bot-squad-seller-care-front'],
      },
    },
    {
      name: ROUTE_NAMES.FRONT_OFFICE.PRODUCT.HOME,
      path: '/:locale/p/:slugV2/:uuid',
      component: () =>
        import(
          '@backmarket/nuxt-layer-base/components/ExternalPagePlaceholder/ExternalPagePlaceholder.vue'
        ),
      meta: {
        disableClientSideNavigation: () => true,
        owners: ['bot-squad-seller-care-front'],
      },
    },
  ]
}

export default routes
